import React from 'react';
import Modal from './Modal';
import TextArea from '../Input/TextArea';

const ConfirmActionModal = ({ action, handleClose, confirmButton, cancelButton, header, message, hasTextBox, text, setText }) => {
	return (
		<Modal
			header={header ? header : "Confirm"}
			handleClose={handleClose}
			cancelButton={{ ...cancelButton }}
			confirmButton={{ label: "Confirm", ...confirmButton, disabled: hasTextBox && text.length === 0 }}
			buttonsClass={hasTextBox ? 'pt-none' : 'pt-xxl'}
		>
			{message ?? `Are you sure you want to ${action}?`}
			{hasTextBox && <TextArea className='mt-l' placeholder='Add comment' style={{ height: 60}} value={text} onChange={(e) => setText(e.target.value)}/>}
		</Modal>
	);
}
export default ConfirmActionModal;